import { StoredFilterItem } from "./StoredFilterItem"

// список сохраненных фильтров табличных компонентов
export class StoredFilter {
    items: StoredFilterItem[] = [];
}